import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const qdrantHealthApi = {
    getHealth: async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/admin/system-management/qdrant-health`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default qdrantHealthApi;

